module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/651275fc77d16a2586317749c28bb799.png";